<template>
  <div class="navbar">
    <h1 class="logo">
      {{ title }}
    </h1>
    <div class="right-menu">
      <div v-if="showAvatar || showAvatarName" class="avatar-container right-menu-item">
        <div class="avatar-wrapper">
          <p v-if="showAvatar&&isdefaultImg" :style="{background:(avatarSrc?avatarSrc:'url('+defaultUrl+')')+'center/contain'}" :class="circleAvatar ? 'circle' : 'normal'" class="user-avatar" @click="goToUserSettingsPage" />
          <p v-else :style="{background:'url('+defaultUrl+')'+'center/contain'}" :class="circleAvatar ? 'circle' : 'normal'" class="user-avatar" @click="goToUserSettingsPage" />
          <div :class="{usernameOnAvatar : showAvatar}" class="username">{{ name }}</div>
        </div>
      </div>
      <div class="right-menu-item hover-effect notifition">
        <el-badge :value="unReadnoticeNumber" class="item" :hidden="unReadnoticeNumber === 0">
          <img src="../../app/common/image/nav/notifition.png" alt="" @click="goToNotificationPage">
        </el-badge>
        <ul v-if="notificitonOutlineInfoList.length>0" class="notificiton-outline-info">
          <li v-for="(item,index) in notificitonOutlineInfoList" :key="index">
            {{ item.title }}
          </li>
          <li class="read-all" @click="goToNotificationPage">{{ $t('layout.BaseLayoutHeader.2596051-0') }}</li>
        </ul>
      </div>
      <div class="right-menu-item hover-effect">
        <img src="../../app/common/image/nav/exit.png" alt="" @click="handleExitClick">
      </div>
    </div>
    <div ref="dialogs" />

  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapState} from 'vuex'
import Breadcrumb from '@/framework/components/Breadcrumb'
import Hamburger from '@/framework/components/Hamburger'
import ErrorLog from '@/framework/components/ErrorLog'
import uiConfig from '@/config/ui-config'

const rightMenuComponents = {}
if (uiConfig.headerRightMenu && uiConfig.headerRightMenu instanceof Array) {
  for (let i = 0; i < uiConfig.headerRightMenu.length; i++) {
    rightMenuComponents[uiConfig.headerRightMenu[i].componentName] = uiConfig.headerRightMenu[i].component
  }
}

const dynamicDialogs = []

import commonControl from '@/framework/common-control'
export default {
  name: 'BaseLayoutHeader',
  components: {
    // Breadcrumb,
    // Hamburger,
    // ErrorLog,
    // Screenfull,
    // SizeSelect,
    // Search
    ...rightMenuComponents
  },
  data() {
    return {
      isdefaultImg: false,
      unReadnoticeNumber: 0,
      notificitonOutlineInfoList: [],
      defaultUrl: require('@/assets/images/default.jpg')
    }
  },
  computed: {
    ...mapState({
      noticeNumber: state => state.app.noticeNumber
    }),
    ...mapGetters([
      'name',
      'sidebar',
      'avatar',
      'device'
    ]),
    logoSrc() {
      return uiConfig.logoSrc
    },
    avatarSrc() {
      if (this.avatar) {
        return this.avatar
      } else {
        return uiConfig.avatarButton.defaultAvatar
      }
    },
    headerRightMenu() {
      return uiConfig.headerRightMenu
    },
    showAvatar() {
      // 只有定义了不显示头像，才不显示，默认为显示
      return !(uiConfig.avatarButton && uiConfig.avatarButton.showAvatar !== undefined
          && uiConfig.avatarButton.showAvatar === false)
    },
    showAvatarName() {
      return !(uiConfig.avatarButton && uiConfig.avatarButton.showName !== undefined
          && uiConfig.avatarButton.showName === false)
    },
    circleAvatar() {
      return !(uiConfig.avatarButton && uiConfig.avatarButton.circle !== undefined
          && uiConfig.avatarButton.circle === false)
    },
    title() {
      if (uiConfig.title) {
        return uiConfig.title
      } else {
        return this.$t('layout.BaseLayoutHeader.2596051-1')
      }
    },
    avatarMenu() {
      return uiConfig.avatarButton.menu
    }
  },
  watch: {
    noticeNumber(val) {
      this.getUnreadMessage()
    },
    avatar(val) {
      if (val) {
        this.isdefaultImg = true
      } else {
        this.isdefaultImg = false
      }
    }
  },
  mounted() {
    let {name, avatar} = this.$store.state.user
    // let userAvatar = JSON.parse(localStorage.getItem('user')).avatar
    // if (userAvatar) {
    //   this.isdefaultImg = true
    // } else {
    //   this.isdefaultImg = false
    // }
    if (!(name && avatar)) {
      let user = JSON.parse(localStorage.getItem('user'))
      this.$store.dispatch('user/setInfo', user)
    }
    this.getUnreadMessage()
    this.getNotificitonOutlineInfo()
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },

    avatarMenuClick(item, index) {
      if (item.event) {
        item.event()
      } else if (item.dialog) {
        if (!dynamicDialogs[index]) {
          let dialog = new (Vue.extend(item.dialog))()
          dialog.$mount()
          this.$refs.dialogs.appendChild(dialog.$el)
          dynamicDialogs[index] = dialog
          dialog.show()
        } else {
          dynamicDialogs[index].show()
        }

      }
    },
    handleExitClick() {
      this.$confirm(this.$t('layout.BaseLayoutHeader.2596051-2'), this.$t('layout.BaseLayoutHeader.2596051-3'), {
        confirmButtonText: this.$t('layout.BaseLayoutHeader.2596051-4'),
        cancelButtonText: this.$t('layout.BaseLayoutHeader.2596051-5'),
        type: 'warning'
      }).then(() => {
        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        let data = {
          request_body: {
            userId: userInfo.userId ? userInfo.userId : null,
            jwttoken: userInfo.jwtToken
          }
        }
        commonControl.logout(data)
      })

    },
    goToNotificationPage() {  // 跳转到通知管理页面
      this.$router.push({path: '/system-settings/notification-management'})
    },
    goToUserSettingsPage() { // 跳转到用户设置页面
      this.$router.push({path: '/system-settings/user-settings'})
    },
    getUnreadMessage() { // 获取未读消息
      let userId = JSON.parse(localStorage.getItem('userInfo')).userId
      commonControl.getUnreadMessage(userId).then((res) => {
        this.unReadnoticeNumber = res
      })
    },
    getNotificitonOutlineInfo() { // 获取用户通知概要信息
      let userId = JSON.parse(localStorage.getItem('userInfo')).userId
      let json = {
        'request_body': {
          'page': 0,
          'size': 5
        }
      }
      commonControl.getNotificationProfile(userId, json).then((res) => {
        this.notificitonOutlineInfoList = res
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/config/styles/variables.scss";
.navbar {
  height: $headerHeight;
  overflow: hidden;
  position: relative;
  background: $headerBackground;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);
  width: calc(100% - #{$sideBarWidth});
  margin-left: $sideBarWidth;
  .logo {
    float: left;
    position: relative;
    margin: 0px;
    padding-left: 20px;
    font-weight: 400;
    font-size: 18px;
    color: $headerContentColor;
    height: 60px;
    line-height: 60px;
    a {
    display: inline-block;
    height: $headerHeight;
    line-height: $headerHeight;
    vertical-align: middle;
    font-size: 20px;
    color: $headerLogoColor;
      img {
        height: 70%;
        vertical-align: middle;
        margin-right: 10px;
      }
    }
  }

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;
    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }
  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: $headerHeight;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 16px;
      height: 100%;
      font-size: 18px;
      color: $headerContentColor;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(255, 255, 255, 0.1)
        }
      }
      &:nth-child(2){
        height: 40px;
        line-height: 40px;
        margin-bottom: 10px;
        border-left: 1px solid #dcdfe6;
        img{
          margin-top: 8px;
        }
      }
      &:nth-child(3){
        img{
          margin-top: 20px;
        }
      }
    }
    .avatar-container {
      // margin-right: 30px;

      .avatar-wrapper {
        position: relative;
        height: $headerHeight;
        padding: calc(#{$headerHeight} * 0.1) 8px;
        line-height: calc(#{$headerHeight} * 0.8);
        display: flex;
        justify-content: space-around;
        .circle {
          background: url('/static/img/default-avatar.185955da.jpg')center/contain;
          border-radius: 50%;
        }
        .normal {
          border-radius: 3%;
        }

        .user-avatar {
          cursor: pointer;
          height: calc(#{$headerHeight} * 0.8);
          margin-top: -3px;
          width: 50px;
          float: left;
        }

        .usernameOnAvatar {
          margin-right: -10px;
          margin-left: 10px;
        }

        .username {
          color: $headerContentColor;
          font-size: 14px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
.hideSidebar .navbar{
  width: calc(100% - 54px);
  margin-left: 54px;
}
::v-deep.el-badge__content.is-fixed{
  top: 9px;
  right: 6px;
}
.notificiton-outline-info{
  position: fixed;
  top: 40px;
  right: 100px;
  list-style: none;
  z-index: 100;
  background-color: #efefef;
  padding: 20px;
  margin: 0;
  max-height: 700px;
  overflow-y: auto;
  display: none;
  li{
    width: 600px;
    margin-bottom: 20px;
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
    font-size: 14px;
    cursor: auto;
    line-height: 1.15;
    &.read-all{
      color: #1e87f0;
      text-align: center;
      border-bottom: unset;
      padding-bottom: 0;
      margin-bottom: 0;
      cursor: pointer;
    }
  }
}
.notifition:hover{
  .notificiton-outline-info{
    display: inline-block;
  }
}

</style>
